import { gql } from '@apollo/client'

/*
Tenant-level fields that useOccupancyToUse filters and ranks on.

Every query whose person is handed to that hook must spread this fragment.
Listing these fields by hand per query is how the hook ends up starved: the
generated types mark them all optional, so omitting one is not a type error,
and the hook then degrades silently to arbitrary DB row order rather than
failing. Keep the contract in one place instead.
*/
export const OCCUPANCY_TO_USE_TENANT_FRAGMENT = gql`
  fragment occupancyToUseTenantFields on unit_occupancy_tenant {
    id
    is_active
    deleted
    move_out_date
    created_at
  }
`
